export default __webpack_public_path__ + "static/media/safe7-intro-ro.0b014789.png";